module.exports = __webpack_public_path__ + "img/infibo-trades-screenshot-ru.5f580afe.png";